/**
 * @generated SignedSource<<2811fbaa5c0779cdea2d13b188a751e9>>
 * @relayHash d8ae146d401c8c2c5b74a1c1ee0482eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d973acede3abccab1537a56516ed3df2dda57816f50c4fe9675611026747d45f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AssetsVerticalVerticalType = "HAM" | "%future added value";
export type RolesAndAccessQuery$variables = {
  after?: string | null;
  cloudId: string;
  first?: number | null;
  roleIds?: ReadonlyArray<string> | null;
  verticalType: AssetsVerticalVerticalType;
};
export type RolesAndAccessQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RolesAndAccess_assignmentsQuery" | "RolesAndAccess_rolesQuery">;
};
export type RolesAndAccessQuery = {
  response: RolesAndAccessQuery$data;
  variables: RolesAndAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 50,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "verticalType"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = {
  "kind": "Variable",
  "name": "verticalType",
  "variableName": "verticalType"
},
v7 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "roleIds",
    "variableName": "roleIds"
  },
  (v6/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "kind": "ScalarField",
  "name": "description"
},
v12 = {
  "kind": "ScalarField",
  "name": "principalId"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RolesAndAccessQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "RolesAndAccess_rolesQuery"
      },
      {
        "args": (v8/*: any*/),
        "kind": "FragmentSpread",
        "name": "RolesAndAccess_assignmentsQuery"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RolesAndAccessQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "LinkedField",
        "name": "assetsVertical_verticalRoles",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "AssetsVerticalRole",
                "kind": "LinkedField",
                "name": "roles",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "roleType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "roleId"
                  },
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              }
            ],
            "type": "AssetsVerticalRolesSuccess"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      },
      {
        "args": (v8/*: any*/),
        "concreteType": "AssetsVerticalRoleAssignmentConnection",
        "kind": "LinkedField",
        "name": "assetsVertical_verticalRoleAssignments",
        "plural": false,
        "selections": [
          {
            "concreteType": "AssetsVerticalRoleAssignmentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AssetsVerticalRoleAssignment",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "principal",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "picture"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "email"
                                  }
                                ],
                                "type": "AtlassianAccountUser"
                              },
                              (v13/*: any*/)
                            ]
                          }
                        ],
                        "type": "AssetsVerticalUserPrincipal"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          {
                            "concreteType": "IdentityGroup",
                            "kind": "LinkedField",
                            "name": "group",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              (v11/*: any*/),
                              (v13/*: any*/)
                            ]
                          }
                        ],
                        "type": "AssetsVerticalGroupPrincipal"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "roleIds"
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v8/*: any*/),
        "filters": [
          "cloudId",
          "verticalType",
          "roleIds"
        ],
        "handle": "connection",
        "key": "RolesAndAccess_assetsVertical_verticalRoleAssignments",
        "kind": "LinkedHandle",
        "name": "assetsVertical_verticalRoleAssignments"
      }
    ]
  },
  "params": {
    "id": "d973acede3abccab1537a56516ed3df2dda57816f50c4fe9675611026747d45f",
    "metadata": {},
    "name": "RolesAndAccessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e87225f7532b51838667fadabee1ec4b";

export default node;
